import React from "react";
import ReactApexChart from "react-apexcharts";
import { Card, Row, Col } from "reactstrap";
import FiscalIndicator from "../Module/FiscalIndicator";

const BarChart = ({ financialRatio, fiscalYearData }) => {
   // 横軸
   const horizontalAxis = fiscalYearData;


  //グラフデータ
  const series = [
    {
      name: "",
      data: financialRatio,
    },
  ];
 

  //グラフオプション
  const options = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      
      // zoom: {
      //   enabled: true,
      // },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "top",
            offsetX: -10,
            offsetY: 0,
            
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          enabled: true,
          position: "top",
        },
      },
    },

    dataLabels: {
      enabled: true,
      position: "top",
      formatter(value) {
        return value.toLocaleString();
      },
      style: {
        colors: ["#495057"],
        fontSize: "10px",
      },
      offsetY: -22, 
 
    },

    xaxis: {
      categories: horizontalAxis,
    },
    yaxis: {
      // min: -1,
      // max:2,
      labels: {
        formatter(value) {
          return value.toLocaleString();
        },
      },
    },
    legend: {
      position: "right",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  };


  return (
    <>
      <div id="chart">
        <Card style={{ paddingTop: 100, paddingBottom: 100 }}>
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={350}
          />
        </Card>
      </div>
    </>
  );
};

export default BarChart;
